export default __webpack_public_path__ + "static/cashflow2-54e38c74762aa2c66c7e1bf586f415e5.jpg";